import Header from '@editorjs/header';
import Quote from '@editorjs/quote';
import List from '@editorjs/list';
import Embed from '@editorjs/embed';
import ImageTool from '@editorjs/image';
import { adminService } from '../../api';

export const createEditorTools = () => ({
    header: {
        class: Header,
        inlineToolbar: true,
        config: {
            placeholder: 'Введите заголовок',
            levels: [2, 3, 4],
            defaultLevel: 2,
        },
    },

    list: {
        class: List,
        inlineToolbar: true,
    },

    embed: {
        class: Embed,
        config: {
            services: { youtube: true },
        },
    },

    image: {
        class: ImageTool,
        config: {
            uploader: {
                uploadByFile: (file) => adminService.uploadContentPostImage(file).then(({ data }) => data),
            },
            types: 'image/*',
        },
    },

    quote: {
        class: Quote,
        inlineToolbar: true,
        config: {
            quotePlaceholder: 'Введите цитату',
            captionPlaceholder: 'Автор',
        },
    },
});

export default createEditorTools;
